import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import config from 'linced-admin/config/environment';

export default class TransactionUploadController extends Controller {
  @service
  fetch;

  @service
  toaster;

  @tracked
  selectedSchool = null;

  @action
  setSelectedSchool(value) {
    this.selectedSchool = value;
  }

  @tracked
  transactionId = null;

  @action
  setTransactionId(value) {
    this.transactionId = value;
  }

  @tracked
  forceSend = false;

  @action
  setForceSend(value) {
    this.forceSend = value;
  }

  @tracked
  sendInProgress = false;

  @action
  submitTransactions() {
    this.sendInProgress = true;
    let options = {
      data: JSON.stringify({
        schoolId: this.selectedSchool.id,
        transactionId: parseInt(this.transactionId, 10),
        forceSend: this.forceSend,
      }),
    };
    let url = `${config.APP.apiHost}/finance/${config.APP.apiPath}/nsw/sap/:sendtransaction`;
    return this.fetch
      .post(url, options)
      .then(() => {
        this.reset();
        this.toaster.success('Transaction sent to SAP.');
      })
      .catch((resp) => {
        if (isEmpty(resp) || isEmpty(resp.message)) {
          this.toaster.error('Failed to send transaction to SAP.');
        } else {
          this.toaster.error(
            `Failed to send transaction to SAP: ${resp.message}`,
          );
        }
      })
      .finally(() => {
        this.sendInProgress = false;
      });
  }

  reset() {
    this.selectedSchool = null;
    this.transactionId = null;
    this.forceSend = false;
    this.sendInProgress = false;
  }
}
